import axios from 'axios';
import { BEPI_API } from '../../../shared/config/bepiApiPaths';

const BASE_URL = `${BEPI_API.client}/quote-details`;

export const ClientQuoteDetailsApi = {
  // Obter detalhes da estimativa e orcamento
  getQuoteDetails: (id) => axios.get(`${BASE_URL}/${id}`),

  // Aceitar estimativa com nota de remessa
  acceptEstimate: (id, formData) => axios.post(`${BASE_URL}/estimates/${id}/accept/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),

  // Recusar estimativa
  refuseEstimate: (id, data) => axios.post(`${BASE_URL}/estimates/${id}/refuse/`, data),

  // Recusar cotação inteira
  refuseQuotation: (id, data) => axios.post(`${BASE_URL}/${id}/refuse`, data),

  // Aceitar orcamento
  acceptBudget: (id) => axios.put(`${BASE_URL}/budgets/${id}/accept/`),

  // Recusar orcamento
  refuseBudget: (id, motivo) => axios.put(`${BASE_URL}/budgets/${id}/refuse/`, null, {
    params: { motivo },
  }),

  // Upload arquivo de orcamento
  uploadBudgetFile: (id, budgetFileOrFormData, fileNameInput) => {
    const formData = budgetFileOrFormData instanceof FormData
      ? budgetFileOrFormData
      : new FormData();

    if (!(budgetFileOrFormData instanceof FormData) && budgetFileOrFormData) {
      formData.append('budget_file', budgetFileOrFormData);
    }

    if (typeof fileNameInput === 'string' && fileNameInput.trim()) {
      formData.append('budget_file_name', fileNameInput.trim());
    }

    return axios.post(`${BASE_URL}/${id}/budget-file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  // Upload arquivo de laudo técnico
  uploadLaudoFile: (id, formData) => axios.post(`${BASE_URL}/${id}/laudo-file`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),

  // Upload nota fiscal de serviço
  uploadNfFile: (id, nfFileOrFormData, nfFileNameInput, fileType = 'nota_fiscal') => {
    const formData = nfFileOrFormData instanceof FormData
      ? nfFileOrFormData
      : new FormData();

    if (!(nfFileOrFormData instanceof FormData) && nfFileOrFormData) {
      formData.append('nf_file', nfFileOrFormData);
    }

    if (typeof nfFileNameInput === 'string' && nfFileNameInput.trim()) {
      formData.append('nf_file_name', nfFileNameInput.trim());
    }

    return axios.post(`${BASE_URL}/${id}/nf-file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { type: fileType }
    });
  },

  // Aceitar orcamento pela cotação
  acceptBudgetByQuoteId: (id) => axios.put(`${BASE_URL}/${id}/accept-budget`),

  // Recusar orcamento pela cotação
  refuseBudgetByQuoteId: (id, motivo) => axios.put(`${BASE_URL}/${id}/refuse-budget`, null, {
    params: { motivo },
  }),

  // Concluir manutenção
  completeMaintenance: (id) => axios.put(`${BASE_URL}/${id}/complete-maintenance`),

  // Atualizar status da cotação (via Admin Home API)
  updateQuotationStatus: (id, status) => axios.put(`/web/admin/home/quotations/${id}/status`, { status }),

  // Obter detalhes de envio
  getShippingDetails: (_id) => Promise.reject(
    // TODO: INEXISTENTE no backend: /web/client/quote-details/{id}/shipping-details
    new Error('Endpoint de shipping-details indisponivel no backend atual.')
  ),
};

